<!-- views/reg.vue -->
<template>
	<div class="reg-container">
		<div class="login-con-form">
			<div class="login-img">
				<el-image style="width:150px; height: 150px;border-radius: 50%;" :src="require('../../assets/logo.png')" :lazy='true' alt='专利平台' fit="cover"></el-image>
			</div>
		<el-form ref="form" :model="form" label-position='right' label-width="80px" :rules="rules" class="reg-form"
			@submit.native.prevent="handlereg">
			<div class="reg-item1">
				<h2 class="title">注册账号</h2>
				<!-- <el-switch class="switch" v-model="value1" active-text="个人用户" inactive-text="企业用户"></el-switch> -->
			</div>
			<el-form-item prop="enterpriseName" label="企业名称" v-if="value1" required>
				<el-input v-model="form.enterpriseName" :clearable='true' type="text" placeholder="请输入企业名称"></el-input>
			</el-form-item>
			<el-form-item prop="account" label="账号" required>
				<el-input v-model="form.account" :clearable='true' type="text" placeholder="请输入手机号/微信号"></el-input>
			</el-form-item>
			<el-form-item prop="nickname" label="昵称" required>
				<el-input v-model="form.nickname" :clearable='true' type="text" placeholder="请输入姓名/公司名称"></el-input>
			</el-form-item>
			<el-form-item prop="password" label="密码" required>
				<el-input v-model="form.password" :show-password='true' :clearable='true' type="password"
					placeholder="请输入新密码,6-20位数字、字母"></el-input>
			</el-form-item>
			<el-form-item prop="newpassword" label="确认密码" required>
				<el-input v-model="form.newpassword" :show-password='true' :clearable='true' type="password"
					placeholder="请确认密码,6-20位数字、字母"></el-input>
			</el-form-item>

			<!-- <el-form-item prop="invite_code" label="邀请码">
				<el-input v-model="form.invite_code" :clearable='true' type="text"
					placeholder="没有可不填"></el-input>
			</el-form-item> -->
			<el-button type="primary" native-type="submit" :loading="loading" class="login-btn">
				注册
			</el-button>
			<el-link class="reg-txt" @click="gotologin" type="primary">已有账号，去登录</el-link>
		</el-form>
		</div>
	</div>
</template>

<script>
	import userApi from '@/api/user'
	export default {
		data() {
			// 禁止中文的校验规则
			const checkChinese = (rule, value, callback) => {
				if (!value) { // 允许空值（如果必填需配合 required 规则）
					return callback();
				}

				// 规则1：长度 6-20 位
				if (value.length < 6 || value.length > 15) {
					return callback(new Error('长度需在6-15位之间'));
				}

				// 规则2：仅允许字母和数字（禁止中文、符号）
				const allowedRegex = /^[a-zA-Z0-9]+$/;
				if (!allowedRegex.test(value)) {
					return callback(new Error('只能包含字母和数字'));
				}

				callback();
			};

			return {
				value1: false,
				form: {
					enterpriseName: '',
					nickname: '',
					password: '',
					newpassword: '',
					invite_code: '',
					account: '',
				},
				rules: {
					enterpriseName: [{
							required: true,
							message: '请输入企业名称',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '请输入企业名称,6-20位',
							trigger: 'blur'
						}
					],
					account: [{
							required: true,
							message: '请输入账号(字母、数字6位以上)',
							trigger: 'blur'
						},
						{
							validator: checkChinese,
							trigger: 'blur'
						}
					],
					nickname: [{
							required: true,
							message: '请输入昵称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 10,
							message: '请输入昵称,最长10位',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					newpassword: [{
							required: true,
							message: '请确认密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
				},
				loading: false,
			}
		},
		methods: {
			gotologin(){
				this.$router.push('login');
			},
			handlereg() {
				if(this.form.password != this.form.newpassword){
					this.$message.error('两次密码不一致');
					return false;
				}
				this.$refs.form.validate(valid => {
					if (valid) {
						this.loading = true;
						if(this.value1){
							this.form.type = 2;
						}else{
							this.form.type = 1;
						}
						userApi.reg(this.form).then(res => {
							this.$message({
							  message: '注册成功',
							  type: 'success'
							});
							this.$router.push('login');
						})
						this.loading = false;
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.reg-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background: linear-gradient(to bottom, #00a0ea 0%, #faf7f8 100%);
	}
	
	.login-con-form{
		display: flex;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0 0 10px rgba(0, 0, 0, .1);
	}
	.login-img{
		width: 180px;
		min-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.reg-item1 {
		display: flex;
		align-items: center;

		.switch {
			margin-left: auto;
		}
	}

	.reg-form {
		width: 360px;
		padding: 40px;
	}

	.title {
		text-align: left;
		color: #333;
	}

	.reg-check {
		text-align: left;
	}

	.reg-btn {
		width: 100%;
		margin-top: 20px;
	}

	.reg-txt {
		margin-top: 18px;
	}
</style>